import React from 'react';
import { Table, Header, Loader, Message, Button } from 'semantic';
import { formatEuro } from 'utils/formatting';
import { withTranslation } from 'react-i18next';
import { request } from 'utils/api';
import { downloadCsv } from 'utils/csv';
import { format } from 'date-fns';

class InvoicesBreakdown extends React.Component {
  state = {
    loading: true,
  };

  componentDidMount() {
    this.fetch();
  }

  async fetch() {
    try {
      const { data } = await request({
        method: 'GET',
        path: '/1/invoices/breakdown/cpo-usage',
      });
      this.setState({
        data,
        loading: false,
      });
    } catch (error) {
      this.setState({
        error,
        loading: false,
      });
    }
  }

  render() {
    const { loading, error, data } = this.state;
    const { t } = this.props;
    return (
      <div>
        <Header as="h3">
          {t(
            'cpoUsageInvoicesFinance.cpoUsageInvoiceHistory',
            'CPO Usage Invoicing History'
          )}
        </Header>
        {loading && <Loader active centered inline="centered" />}
        {error && <Message error content={error.message} />}
        {data && (
          <React.Fragment>
            <Table celled>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>
                    {t('cpoUsageInvoicesFinance.columnMonth', 'Month')}
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    {t(
                      'cpoUsageInvoicesFinance.columnNoInvoices',
                      'No Invoices'
                    )}
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    {t(
                      'cpoUsageInvoicesFinance.columnPlatformFees',
                      'Platform Fees'
                    )}
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    {t(
                      'cpoUsageInvoicesFinance.columnDirectPaymentFees',
                      'Direct Payment Fees'
                    )}
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    {t(
                      'cpoUsageInvoicesFinance.columnAccountingFees',
                      'Accounting Fees'
                    )}
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    {t('cpoUsageInvoicesFinance.columnUsageFees', 'Usage Fees')}
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    {t(
                      'cpoUsageInvoicesFinance.columnTotalExVAT',
                      'Total Ex VAT'
                    )}
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    {t(
                      'cpoUsageInvoicesFinance.columnTotalVAT',
                      'Total Inc VAT'
                    )}
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {data.map((item) => {
                  const { year, month } = item._id;

                  return (
                    <Table.Row key={`${year}-${month}`}>
                      <Table.Cell>
                        {year} / {month}
                      </Table.Cell>
                      <Table.Cell textAlign="right">{item.total}</Table.Cell>
                      <Table.Cell textAlign="right">
                        {formatEuro(item.totalPlatformFees, 2, true)}
                      </Table.Cell>
                      <Table.Cell textAlign="right">
                        {formatEuro(item.totalDirectPaymentFees, 2, true)}
                      </Table.Cell>
                      <Table.Cell textAlign="right">
                        {formatEuro(item.totalAccountingFees, 2, true)}
                      </Table.Cell>
                      <Table.Cell textAlign="right">
                        {formatEuro(item.totalUsageFees, 2, true)}
                      </Table.Cell>
                      <Table.Cell textAlign="right">
                        {formatEuro(item.totalAmount, 2, true)}
                      </Table.Cell>
                      <Table.Cell textAlign="right">
                        {formatEuro(item.totalAmountWithVat, 2, true)}
                      </Table.Cell>
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>
            <div>
              <Button
                onClick={() => {
                  downloadCsv(
                    data.map((item) => {
                      const { _id, ...rest } = item;
                      const { year, month } = _id;
                      return {
                        month: `${year} / ${month}`,
                        ...rest,
                      };
                    }),
                    null,
                    `cpo-usage-invoices-${format(new Date(), 'yyyy-MM-dd')}.csv`
                  );
                }}
                icon="download"
                content="Export CSV"
                basic
              />
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default withTranslation()(InvoicesBreakdown);
